import { Component, OnInit , Input , Output, ElementRef , ViewChild, EventEmitter, OnChanges } from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';
//import { ScriptloadService } from '../../service/scriptload.service';
import {ScriptloadService} from '../../service/scriptload.service';

import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

declare var RapydScript : any;
declare var evaluateClear : any;
//declare var print2 : any;


@Component({
  selector: 'app-codepython',
  templateUrl: './codepython.component.html',
  styleUrls: ['./codepython.component.scss'],
})
export class CodepythonComponent implements OnInit {

  @Input() code : string;
  @Input() id : number;
  
  
  @Output() eventchild = new EventEmitter<string>();
  
  code2 : string;

  content : string = "Le contenu";
  contentap : string = "";
  title = "";
  visicanvas = false;
  
  //compile le code en javascript
  compiler : any;

  @ViewChild('idcode', {static: true}) idcode : ElementRef;
  @ViewChild('el', {static: true}) idel : ElementRef;
  @ViewChild('idoutput', {static: true}) idoutput : ElementRef;
  @ViewChild('turtlecanvas1', {static: true}) turtlecanvas : ElementRef;
  
  constructor(public gfichier : GfichierService,
    public scriptload : ScriptloadService) {}

  ngOnInit() {

    this.eventchild.emit("hidebtvalider");

   
    this.loadScripts();
   // this.mjBalises();

   this.turtlecanvas.nativeElement.style = 'display:none;'
  
   

  }//fin ngoninit

  ngOnChanges() { 

    this.mjBalises();


  }




//mose a jour balises
convertFct(str:string):string {
  str = str.replace(/print\(/g, 'print2(');
  str = str.replace(/\ntype\(/g, '\ntype3(');
  str = str.replace(/type\(/g, 'type2(');
  //str = str.replace(/type\((.)\)/g,'print2(typeof $1)');
  str = str.replace(/input\(/g,"prompt(");
  str = str.replace(/int\(/g,"parseInt(");
  str = str.replace(/float\(/g,"parseFloat(");
  //alert(str.search(/import/g));
  
  return str;
  
}


//mise a des jour balises
mjBalises() {
  //document.getElementById("turtlecanvas").style.display = 'none'; 
  this.turtlecanvas.nativeElement.style = 'display:none;'
  
  let str : string ;//= this.code;
  
  if(this.gfichier.getCode2(this.id)) {
    str =  this.gfichier.getCode2(this.id);
  }  else {
    str = this.code;
  } 
  
  str = str.replace(/\n/g,"<br/>");
  str = str.replace(/ /g,"&nbsp;");
  
  this.code2 = str;
  //this.code2= this.code;
  
} //fin mjbalise



  compileEnJs() {
    //alert(this.code2);
    //let str = this.compiler.compile(this.code2);
    this.gfichier.setCode2(this.code2,this.id);

    this.eventchild.emit("showbtvalider");

    let str:string=this.idel.nativeElement.innerText;
    let noerror : boolean = true;

    
    //recherche import turtle
    let myreg = /import([^]+)turtle/i;
    this.visicanvas = myreg.test(str);
    //this.turtlecanvas.nativeElement.
    //alert(myreg.test(str));
    if (myreg.test(str)) { 
      // document.getElementById("turtlecanvas").style.display = 'block';
      
      this.turtlecanvas.nativeElement.style = 'display:block;'
  
       this.scriptload.loadScript('turtle').then(res => {
        //alert("cs101");
       }).catch(error => alert("javascript error"));
    
    } 
    else
    this.turtlecanvas.nativeElement.style = 'display:none;'
    // document.getElementById("turtlecanvas").style.display = 'none'; 
    
       str = str.replace(myreg,"initialise()"); 
      
    try {
      
  //alert(myreg.test(this.idel.nativeElement.innerText));
  //alert("kkjkkj");  
  
      str = this.compiler.compile(str);
      
    } catch(err) {
       let strerr = String(err);
       let posi1 = strerr.search(":")+1; 
       let posi2 = strerr.search("\n");
       noerror = false; 
       this.idoutput.nativeElement.innerHTML = "<text><font color='red'>Error:</font>" + strerr.substring(posi1,posi2)+"</text>"; 
       //alert(strerr.substring(posi1,posi2)); 
      
      };
    //alert(this.idel.nativeElement.innerText);
    if(noerror) {
       this.idcode.nativeElement.value = this.convertFct(str); 
       evaluateClear("isn-ex1");

    }
    //alert(this.idoutput.nativeElement.innerHTML);
    setTimeout(() => {
      this.gfichier.setOutput(this.idoutput.nativeElement.innerHTML , this.id);
      //alert(this.gfichier.getOutput(this.id));
      if(this.visicanvas) {
        let dataURL = this.turtlecanvas.nativeElement.toDataURL();
        this.gfichier.setCanvas(dataURL , this.id);
        this.gfichier.setVisiCanvas(true , this.id);
        
        dataURL = null;
        //alert(dataURL);
      }
    }, 500);
    
    
    //this.code = this.code2;
  
  }

  


  loadScripts() {
    this.scriptload.loadScript('cs101').then(res => {
      //alert("cs101");
    }).catch(error => alert("cs101 error"));
  
    
  
    // this.scriptload.loadScript('cs102').then(res => {
     // alert("cs102");
   // }).catch(error => alert("cs102 error"));
    
    
    
    
    // You can load multiple scripts by just providing the key as argument into load method of the service
    
    this.scriptload.loadScript('rapydscript').then(res => {
      //script chargé
      this.compiler = RapydScript.create_embedded_compiler();
    }).catch(error => console.log(error));
    
  }
  


     
     initialiser() {
      
      let str =  this.gfichier.getCode(this.id);
      str = str.replace(/\n/g,"<br/>");
      str = str.replace(/ /g,"&nbsp;");
      
      this.code2 = str;
     }

}
